'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _split2 = require('lodash/split');
var _split3 = _interopRequireDefault(_split2);
var _sortBy2 = require('lodash/sortBy');
var _sortBy3 = _interopRequireDefault(_sortBy2);
var _reduce2 = require('lodash/reduce');
var _reduce3 = _interopRequireDefault(_reduce2);
var _map2 = require('lodash/map');
var _map3 = _interopRequireDefault(_map2);
var _isNil2 = require('lodash/isNil');
var _isNil3 = _interopRequireDefault(_isNil2);
var _isEmpty2 = require('lodash/isEmpty');
var _isEmpty3 = _interopRequireDefault(_isEmpty2);
var _head2 = require('lodash/head');
var _head3 = _interopRequireDefault(_head2);
var _has2 = require('lodash/has');
var _has3 = _interopRequireDefault(_has2);
var _get2 = require('lodash/get');
var _get3 = _interopRequireDefault(_get2);
var _findIndex2 = require('lodash/findIndex');
var _findIndex3 = _interopRequireDefault(_findIndex2);
var _dotstatsuiteSdmxjs = require('@sis-cc/dotstatsuite-sdmxjs');
var _dimensionUtils = require('../dimension-utils');
var _observationFormater = require('../observation-formater');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var getDimensionValues = function getDimensionValues(splitObservationKey, dimensions, dimensionsWithValuesIndexedById, rejectedId, display) {
  return (0, _reduce3.default)(splitObservationKey, function (memo, dimensionValueIndex, dimensionIndex) {
    var dimension = (0, _get3.default)(dimensions, '[' + dimensionIndex + ']', {});
    if ((0, _has3.default)(dimensionsWithValuesIndexedById, dimension.id) && dimension.id !== rejectedId) {
      var dimensionValue = (0, _get3.default)(dimension, 'values[' + dimensionValueIndex + ']', {});
      memo[dimensionValue.id] = (0, _extends3.default)({}, dimensionValue, {
        name: (0, _dimensionUtils.dimensionValueDisplayAt)(dimension, dimensionValueIndex, display)
      });
    }
    return memo;
  }, {});
};
var series = function series(observations, dimensions, dimensionsWithValuesIndexedById, timePeriodDimensionIndex, display, formaterAttrs) {
  var rawSeries = (0, _reduce3.default)(observations, function (memo, o, k) {
    var oDimensionValuesIndexes = (0, _split3.default)(k, ':');
    var timePeriodDimension = (0, _get3.default)(dimensions, '[' + timePeriodDimensionIndex + ']');
    var timePeriodDimensionValueIndex = oDimensionValuesIndexes[timePeriodDimensionIndex];
    var timePeriod = (0, _get3.default)(timePeriodDimension, 'values[' + timePeriodDimensionValueIndex + ']');
    var datapoint = {
      x: timePeriod.start,
      y: (0, _head3.default)(o),
      timeLabel: timePeriod.name,
      formatedValue: (0, _observationFormater.getFormatedObservation)(o, formaterAttrs),
      dimensionValues: getDimensionValues(oDimensionValuesIndexes, dimensions, dimensionsWithValuesIndexedById, timePeriodDimension.id, display)
      //index: Number(timePeriodDimensionValueIndex)
    };
    var category = (0, _dimensionUtils.categoryDisplay)(oDimensionValuesIndexes, dimensions, dimensionsWithValuesIndexedById, timePeriodDimension.id, display);
    var key = (0, _dimensionUtils.categoryDisplay)(oDimensionValuesIndexes, dimensions, dimensionsWithValuesIndexedById, timePeriodDimension.id, 'code');
    if ((0, _isNil3.default)(key) || (0, _isEmpty3.default)(key)) {
      key = 'uniq-dp';
    }
    var serieIndex = (0, _findIndex3.default)(memo, function (serie) {
      return serie.key === key;
    });
    if (serieIndex !== -1) memo[serieIndex].datapoints.push(datapoint);else memo.push({
      datapoints: [datapoint],
      category: category,
      key: key
    });
    return memo;
  }, []);
  return (0, _map3.default)(rawSeries, function (serie) {
    return (0, _extends3.default)({}, serie, {
      datapoints: (0, _sortBy3.default)(serie.datapoints, function (datapoint) {
        return datapoint.x;
      })
    });
  });
};
exports.default = function (_ref, dimensionsWithValuesIndexedById, display, formaterAttrs) {
  var observations = _ref.observations,
    dimensions = _ref.dimensions;
  var timePeriodDimension = (0, _dotstatsuiteSdmxjs.getTimePeriodDimension)({
    dimensions: dimensions
  });
  var timePeriodDimensionIndex = timePeriodDimension ? timePeriodDimension.index : -1;
  var timePeriodDimensionHasManyPeriods = !(0, _has3.default)(dimensionsWithValuesIndexedById, (0, _get3.default)(timePeriodDimension, 'id'));
  if (timePeriodDimensionIndex === -1 || timePeriodDimensionHasManyPeriods) return [];
  return series(observations, dimensions, dimensionsWithValuesIndexedById, timePeriodDimensionIndex, display, formaterAttrs);
};